baseExclusions = [
  /^subscription$/  
  /^resetExclusions$/  
  /^_asyncComputed$/
  /^async_computed\$/
]
export default
  # override resetExclusions if you find values that _should not_ be reset.
  data: ->
    subscription: null
    resetExclusions: []      
  created: ->
    return unless (@ != @$root); # guard against running this in the root component.    
    @subscribe()  
  beforeDestroy: ->
    return unless (@ != @$root); # guard against running this in the root component.        
    @unsubscribe()
  methods:
    subscribe: -> #override this in compoents that need other mutations
      return unless (@$store); # guard against components that don't use vuex.
      @subscription = @$store.subscribe (mutation, state) =>
        switch mutation.type
          when 'reset'            
            @reset()        
    unsubscribe: ->
      if typeof @subscription == 'function'
        @subscription()
    reset: ->
      origin = @$options.data.call(@)
      exclusions = baseExclusions.concat(@resetExclusions or [])
      for key of origin when exclusions.some((re) -> re.test(key))
        delete origin[key]
      Object.assign @$data, origin
      